import(/* webpackMode: "eager" */ "/vercel/path0/apps/discovericl/app/site/[host]/error.tsx");
